/**
 * Where to land after a successful login.
 *
 * Honours `?redirect=…` so a flow that bounced the user to the login page (the
 * MCP OAuth consent screen, for example) resumes where it left off instead of
 * dumping them on the dashboard.
 *
 * SECURITY — only a same-origin absolute PATH is accepted. An absolute URL, or a
 * protocol-relative one like `//evil.com`, would make this an open redirect: an
 * attacker could send a victim a genuine BeX login link and have them bounced to
 * a look-alike site the instant they authenticate, with the login itself being
 * completely real. Anything that is not a plain `/path` is ignored.
 *
 * Kept in its own module (no React, no app imports) so the guard is unit-testable
 * without pulling in the whole application context.
 */
export function postLoginTarget(search) {
    const query = typeof search === 'string'
        ? search
        : (typeof window !== 'undefined' ? window.location.search : '');
    const raw = new URLSearchParams(query).get('redirect');
    // Must start with a single '/' — rejects '//evil.com', 'https://…', 'javascript:…'.
    return raw && /^\/(?!\/)/.test(raw) ? raw : '/redirect';
}

export default postLoginTarget;
